import React from 'react';
import GridIcon from 'assets/svg/layout-grid.svg';
import ChartUpIcon from 'assets/svg/chart-up.svg';
import GridActiveIcon from 'assets/svg/layout-grid-active.svg';
import styled from '@emotion/styled';
import withEvents from 'analytics/withEvents';
import { SearchViewMode } from 'components/list-view-switcher/constants';
import { Button } from 'ds/components/button';
import Tag, { TagType } from 'components/cards/new-layout/components/Tag';
import { useLocale } from 'locale';
import { setAuthModal } from 'store/state/app/actions';
import { AuthenticationModalType } from 'components/authentication/types';
import { AuthModalSource } from 'store/state/app';
import { isVisitorUserSelector } from 'store/state/domainData/selectors';
import { connect } from 'react-redux';
import { State, RootAction } from 'store/state';
import { Dispatch } from 'redux';
import { SearchViewSwitcherProps } from '.';


const LoginBtn = styled(Button)<{ isActive: boolean; }>(({ theme, isActive }) => isActive ? ({}) : ({
  color: theme.colors.neutrals.grey2,
  backgroundColor: theme.colors.neutrals.grey10,
  'svg path': {
    stroke: theme.colors.neutrals.grey2,
  },
}));

const ListViewSwitcherWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ListViewSwitcherItem = styled.div`
  ${({ theme }) => `
    margin: 0 ${theme.spacing(0.5)};
  `}
  cursor: pointer;
`;


export interface InvestorsViewSwitcherProps extends SearchViewSwitcherProps {
  isVisitor: boolean;
  onOpenAuthModal: () => void;
}

const InvestorsViewSwitcher: React.FC<InvestorsViewSwitcherProps> = ({ mode, setMode, onClick, onOpenAuthModal, isVisitor }) => {
  const isGrid = mode === SearchViewMode.Grid;
  const { t } = useLocale();
  const onToggleClick = (view: SearchViewMode) => {
    onClick(view);
    setMode(view);
  };

  const setGridMode = () => onToggleClick(SearchViewMode.Grid);
  const setListMode = () => onToggleClick(SearchViewMode.List);

  const listMode = (
    <LoginBtn isActive={!isGrid} onClick={setListMode} isInitialIconColor size="medium" mode="ghost" fullWidth>
      {t('widget.search.toggle.login.btn')}
      <ChartUpIcon />
      {isVisitor && <Tag type={TagType.New} />}
    </LoginBtn>
  );

  const gridMode = (
    <ListViewSwitcherItem onClick={setGridMode}>
      {isGrid ? <GridActiveIcon /> : <GridIcon />}
    </ListViewSwitcherItem>
  );

  return (
    <ListViewSwitcherWrapper>
      {listMode}
      {gridMode}
    </ListViewSwitcherWrapper>
  );
};


const mapStateToProps = (state: State) => ({
  isVisitor: isVisitorUserSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onOpenAuthModal: () => dispatch(setAuthModal({ type: AuthenticationModalType.Investors }, { isUserInitiated: true, source: AuthModalSource.MarketplaceInvestors })),
});

const withEventsListViewSwitcher = withEvents<InvestorsViewSwitcherProps>(sendEvent => ({
  onClick: (view) => sendEvent('search_card_type_toggle_click', 'search', {
    event: {
      'card_type_selected': view === SearchViewMode.Grid ? 'square' : 'investors_view',
    },
  }),
}))(InvestorsViewSwitcher);

const connectedInvestorsViewSwitcher = connect(mapStateToProps, mapDispatchToProps)(withEventsListViewSwitcher);

export default connectedInvestorsViewSwitcher;
